import { type ReactNode, useCallback } from "react";

import { useDispatch } from "react-redux";

import { useTranslate } from "@similarweb/i18n-provider";
import { SuccessToastContent } from "@similarweb/ui-components";

import { showSuccessToast } from "app/actions/toast_actions";

const TOAST_DURATION_MS = 4000;

export const useSuccessToast = () => {
    const dispatch = useDispatch();
    const { translate } = useTranslate();

    /** For text that is already resolved, e.g. a message built from several translated parts. */
    const showSuccessMessage = useCallback(
        (message: ReactNode) => {
            dispatch(
                showSuccessToast(<SuccessToastContent>{message}</SuccessToastContent>, Date.now(), TOAST_DURATION_MS),
            );
        },
        [dispatch],
    );

    const showSuccess = useCallback(
        (translationKey: string, params?: Record<string, number | string>) => {
            showSuccessMessage(translate(translationKey, params));
        },
        [showSuccessMessage, translate],
    );

    return { showSuccess, showSuccessMessage };
};
